import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cx } from '../../utils/cx';
import { Icon } from '../../utils/icon';

export interface EmptyStateProps {
  icon?: LucideIcon;
  /** Custom artwork instead of an icon, e.g. a Nest illustration. */
  art?: ReactNode;
  title: ReactNode;
  /** §23.4: guide the next step ("it takes 2 minutes"). */
  description?: ReactNode;
  actions?: ReactNode;
  size?: 'sm' | 'md';
  headingLevel?: 2 | 3 | 4;
  className?: string;
}

export function EmptyState({
  icon,
  art,
  title,
  description,
  actions,
  size = 'md',
  headingLevel = 2,
  className,
}: EmptyStateProps) {
  const Heading = `h${headingLevel}` as const;
  return (
    <section className={cx('kd-empty', className)} data-size={size}>
      {art ??
        (icon && (
          <span className="kd-empty__icon">
            <Icon icon={icon} size={size === 'sm' ? 20 : 28} />
          </span>
        ))}
      <Heading className="kd-empty__title">{title}</Heading>
      {description && <p className="kd-empty__description">{description}</p>}
      {actions && <div className="kd-empty__actions">{actions}</div>}
    </section>
  );
}
